export default __webpack_public_path__ + "static/media/email-kocek-banner.de28059e.png";